import { useEffect } from "react";
import { NOTIFICATION_TYPE, Store } from "react-notifications-component";
import { useSelector } from "react-redux";
import {
	NotificationModel,
	removeNotification,
} from "../../redux/slices/notification-slice";
import { store } from "../../redux/store";
let displayed: any[] = [];

const RxNotification = () => {
	const notifications = useSelector(
		(store: any) => store.notifications.notifications || []
	);
	const addDisplayed = (id: any) => {
		displayed = [...displayed, id];
	};

	const removeDisplayed = (id: any) => {
		displayed = [...displayed.filter((key) => id !== key)];
	};

	const getTitle = (title: NOTIFICATION_TYPE): string => {
		switch (title) {
			case "info":
				return "Bilgilendirme";
			case "danger":
				return "Hata";
			case "success":
				return "";
			case "default":
				return "";
			case "warning":
				return "Uyarı";
		}
	};
	useEffect(() => {
		notifications.forEach((notification: NotificationModel) => {
			if (displayed.includes(notification.id)) return;
			if (notification.message.trim() === "") return;
			addDisplayed(notification.id);
			Store.addNotification({
				id: notification.id,
				title: getTitle(notification.type),
				message: notification.message,
				type: notification.type,
				insert: "top",
				container: "top-right",
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
				onRemoval: (id, removedBy) => {
					store.dispatch(removeNotification(id));
					removeDisplayed(id);
				},
			});
			// enqueueSnackbar(notification.message, {
			// 	key: notification.id,
			// 	variant: notification.type as VariantType,
			// 	onExited: (event, key) => {
			// 		store.dispatch(removeNotification(key));
			// 		removeDisplayed(key);
			// 	},
			// 	action: (key) => (
			// 		<Button onClick={() => closeSnackbar(key)}>X</Button>
			// 	),
			// });
			// addDisplayed(notification.id);
		});
	}, [notifications]); // eslint-disable-line

	return null;
};

export default RxNotification;
